import debug from 'webmd-debug'
import cookie from 'webmd-cookie';

/*
 * Setting of Optimera is called in webmd-vue-ad. It will pass the pos and Div Id to it.
 * Here the oVa value is set with key Div Id and value NULL
 * Once after the score file is fetched, In webmd-ads (in defineAd function) setting the optimera key value
 * Implented the promise for score file, Only after it resolves then only slot targets will set      
 */
let optiCommon, optimera = {};

if (typeof window !== 'undefined') {
	try {
        window.performance.mark('ads-code-load');
        debug('WebMD ads code loaded (Perf-Mark)');
    } catch (e) {
        debug(e)
    }
    

    window.oDv = ["25"];
    window.oVa = {};
    optimera = {
        /**
         * https://jira.internetbrands.com/browse/PPE-288152 - Check the pdf file attached to the story
         * Optimera ignore: native ads, 1x1 and outofpage pixels
         */
        isOpsCalled: false,
        passOptimeraPos: {
            101: '101',
            121: '121',
            113: '113',
            137: '137',
            105: '105',
            111: '111',
            112: '112',
            114: '114',
            131: '131',
            132: '132',
            133: '133',
            138: '138',
            141: '141',
            404: '404',
            700: '700',
            701: '701',
            921: '921',
            923: '923',
            1921: '1921',
            1923: '1923',
            2025: '2025',
            2026: '2026'
        },
        setoDv: function (adDivId) {
            window.oDv.push(adDivId);
        },
        setoVa: function (adDivId) {
            if (!window.oVa[adDivId] && !this.isOpsCalled) {
                window.oVa[adDivId] = ["NULL"];
            }
        },
        /**
         * https://jira.internetbrands.com/browse/PPE-288152
         * Add ad divs to oDv array which are not 1x1, native and out of page
         * @param {string} pos
         * @param {string} id
         */
        setOptimera: function (pos, id) {
            if (this.ispassOptimeraPos(pos)) {
                this.setoDv(id);
                this.setoVa(id);
            }
        },

        ispassOptimeraPos: function (pos) {
            if (pos) {
                return this.passOptimeraPos[pos];
            }
            return true;
        },
        // fire optimera script before header bidding
        // Do not edit
        //promise to check the load of the score file
        loadScript: function (tagSrc, scriptTag) {
            var placeTag = document.getElementsByTagName("script")[0];

            if (tagSrc.substr(0, 4) !== 'http') {
                var isSSL = true;
                tagSrc = (isSSL ? 'https:' : 'http:') + tagSrc;
            }
            scriptTag.type = 'text/javascript';
            scriptTag.src = tagSrc;
            scriptTag.async = true;
            placeTag.parentNode.insertBefore(scriptTag, placeTag);

        },
        reInit: function () {
            //PPE-337073: header vendor code for IA pages
            // Grabbing the initial_url_path cookie and verifying the url change, if yes trigger the code
            var initial_url_path = cookie('initial_url_path');
            if (initial_url_path) {
                initial_url_path = JSON.parse(initial_url_path);
                if (initial_url_path.url !== window.location.pathname) {
                    webmd.optimera.init();
                }
            }
        },
        shouldRemoveAds: function() {
            // Check if window.location and window.location.search are defined
            if (typeof window !== 'undefined' && window.location) {
                return window.location.href.indexOf('conmktvid') > -1;
            }
            return false; // Return false if the checks fail
        },
        init: function () {
            if (this.shouldRemoveAds()) {
                debug("Ads initialization skipped due to 'conmktvid' parameter in URL.");
                return; // Skip the rest of the initialization if 'conmktvid' is present
            }
            // Disable vendor based on ads admin tool data
            if (window.globalConfig && window.globalConfig.ads) {

                let vendorConfig = window.globalConfig.ads.vendorConfig;
                let optimeraConfig = vendorConfig.optimera ? vendorConfig.optimera : {};
                let location = cookie.getJson('gtinfo');

                /**
                 *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
                 *  hence text transform is done.
                 */
                let isLocationAdded = false;
                let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
                let locationList = optimeraConfig.location ? optimeraConfig.location : [];

                /** 
                 *  If the gtinfo is not available and only some of the locations are selelcted, 
                 *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
                 *  as default behavior. 
                 * 
                 *  If location property is undefined or no countries are added in location array 
                 *  or all the countries are selected, then it can be considered as 
                 *  all the locations are selected and not required to check for gtinfo.
                 *  Countries available in WebMD gtinfo file : 249
                 */
                if (!(countryCode == '' && locationList.length > 0 && locationList.length < 249)) {
                    if (locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode)) {
                        isLocationAdded = true;
                    }
                    /**
                     *  If disable is true and the location is included in the location array, 
                     *  then vendor should not be loaded.   
                     *  If disable is set to false and certain countries are added in location array, 
                     *  then for the countries that are not added in the array can be considered 
                     *  to have disable : true and vendor should not be loaded in this case. 
                     */
                    if (optimeraConfig.disable && isLocationAdded) {
                        return false;
                    } else if (!(optimeraConfig.disable) && !isLocationAdded) {
                        return false;
                    }
                }
            }

            //PPE-411484 don't execute on member pages
            // if we are on member page, return immediately
            if ((/member./).test(location.host)) {
                return;
            }

            // block vendor on sensitive pages 
            if (window.s_sensitive && window.s_sensitive === "true") {
                return false;
            }

            //PPE-324582 : Disable Vendor
            //Disable vendor if url containts vendor=0 or optimera=0
            var url = (document.referrer) ? document.referrer : document.location.href;
            if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('opt=0') > -1)) {
                debug('optimera not needed.');
            }
            else {

                // self invoking the function to load optimera splitter library
                const loadSplitter = new Promise((resolve, reject) => {
                    var libraryTag = document.createElement('script');
                    this.loadScript('https://img.lb.wbmdstatic.com/webmd_static_vue/file-explorer/webmd/js/media/optiCommon.js', libraryTag);
                    libraryTag.onload = function () {
                        optiCommon = window.optiCommon || {};
                        optiCommon.init({
                            splitters: {
                                additionalOptimeraParams: ['country'],
                                customParams: [],
                            }
                        });
                        const country = optiCommon.getOptimeraParams().country.split('-')[1];
                        if (['us', 'au', 'ca', 'gb'].includes(country)) {
                            optiCommon.overrideOptimeraParamValue('country', country);
                        } else {
                            optiCommon.overrideOptimeraParamValue('country', 'other');
                        }
                        resolve();
                    }
                })
                .then(() => {
                    var scriptTag = document.createElement('script');

                    var optimeraHost = window.location.host;
                    var optimeraPathName = window.location.pathname;
                    this.loadScript("https://dyv1bugovvq1g.cloudfront.net/" + window.oDv[0] + "/" + optimeraHost + optimeraPathName + ".js", scriptTag);

                    /**
                     * performance mark to spot when optimera code has started loading
                     */
                    try {
                        window.performance.mark("optimera-load-start");
                        window.performance.measure('measure-optimera-load-start', 'ads-code-load', 'optimera-load-start');
                        debug('(Perf-Mark) Optimera load started -> ' + window.performance.getEntriesByName('measure-optimera-load-start', 'measure')[0].duration);

                    } catch (e) {
                        window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-optimera", "webmd-optimera-load-failed");
                        debug(e)
                    }

                    window.__optimeraPromise = new Promise(function (resolve, reject) {
                        scriptTag.onload = function () {
                            /**
                             * performance mark to spot when optimera code has loaded
                             */
                            try {
                                window.performance.mark('optimera-loaded');
                                window.performance.measure('measure-optimera-loaded', 'ads-code-load', 'optimera-loaded');
                                debug('(Perf Mark) Optimera loaded -> ' + window.performance.getEntriesByName('measure-optimera-loaded', 'measure')[0].duration);

                            } catch (e) {
                                debug(e)
                            }

                            if (optiCommon) {
                                oVa = optiCommon.getSplitterScores();
                                debug('Optimera splitter scores are defined');
                            }
                            resolve();
                            if (opTimeoutRequestAds) {
                                clearTimeout(opTimeoutRequestAds);
                            }
                            debug('optimera score file loaded');
                        };

                        // created a timeout to reject promise if not resolved
                        var opTimeoutRequestAds = setTimeout(function () {
                            reject('Optimera promise timed out')
                            window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-optimera", "webmd-optimera-scores-timedout");
                        }, 800);

                    });
                });

                var optimeraOpsScript = document.createElement('script');
                optimeraOpsScript.async = true;
                optimeraOpsScript.type = 'text/javascript';
                optimeraOpsScript.src = "https://d15kdpgjg3unno.cloudfront.net/oPS.js?cid=" + window.oDv[0];
                document.head.appendChild(optimeraOpsScript);
                
            }

        }
    };

    //self invoking the init function for Initial load
    optimera.init();
    // initialize the third party service namepace, command queue
    window.tpsvc = window.tpsvc || {};
    // The ads code will execute every command inside this queue before an ad request is made
    window.tpsvc.cmds = window.tpsvc.cmds || [];
    window.tpsvc.cmds.push(optimera.reInit);

    window.webmd = window.webmd || {};
    webmd.optimera = optimera;
}

export default optimera;
